export const WIZARD_STEPS = {
    1: {
        targetSection: 'stair-type-container',  // We'll add this ID to the first flex container
        content: '<h3>Select your stair type and configuration</h3><p>If you are unsure which staircase type will work in your situation, feel free to give the Stairworks team a call to discuss on 027-7007-159</p>',
        mobileMenuRequired: true
    },
    2: {
        targetSection: 'stair-specs-container', // We'll add this ID to the sliders/controls section
        content: '<h3>Staircase Specifications</h3><p>adjust your project specs, you can use the approx height helper to help you select the correct details</p>',
        highlightHelpers: true
    },
    3: {
        targetSection: 'update-address-section', // This already exists
        content: '<h3>Flexible Site Locations</h3><p>If you\'re working on multiple projects you can update the site address here to generate a new quote for each project.</p>'
    },
    4: {
        targetSection: 'quote-controls', // This already exists
        content: '<h3>Get a Detailed Breakdown Sent to You</h3><p>click the generate detailed quote button to get a detailed breakdown and accurate quote including all product specs, install info, and no allowances.</p>'
    }
};

const SECTION_CONFIG = {
    'stair-type-container': {
        mobileOnly: true,
        order: 1,
        transitionDelay: 0
    },
    'stair-specs-container': {
        mobileOnly: true,
        order: 2,
        transitionDelay: 0
    },
    'update-address-section': {
        mobileOnly: false,
        order: 3,
        transitionDelay: 0
    }
};

export const WIZARD_CONFIG = {
    animationDuration: 50,
    overlayColor: 'rgba(0, 0, 0, 0.7)',
    highlightClass: 'wizard-highlight',
    activeClass: 'wizard-active',
    zIndexBase: 996,  // Just below form-overlay (997)
    sectionConfig: SECTION_CONFIG
};
